import React from 'react';
import DashboardContext from '../DashboardContext';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';

import 'typeface-roboto';

const DashboardList = () => {
  const ctx = React.useContext(DashboardContext);
  const setSelectedDashboard = ctx.setSelectedDashboard;
  
  const handleSelect = React.useCallback(
    (dashboard) => setSelectedDashboard(dashboard),
    [setSelectedDashboard]
  );

  return (
    <div>
      <List>
        {ctx.dashboards.map((dashboard) => (
          <DashboardListItem
            dashId={dashboard.dashboard}
            onSelect={handleSelect}
            key={dashboard.dashboard}
          />
        ))}
      </List>
    </div>
  );
};

const DashboardListItem = ({ onSelect, dashId }) => {
  const handleClick = React.useCallback(() => onSelect(dashId), [
    onSelect,
    dashId,
  ]);

  return (
    <ListItem button onClick={handleClick}>
      <ListItemText primary={dashId} />
    </ListItem>
  );
};

DashboardListItem.propTypes = {
  onSelect: PropTypes.func.isRequired,
  dashId: PropTypes.any,
};

export default DashboardList;
